import ImagesFooter2025FacebookSvg from '@/public/images/footer-2025/facebook.svg';
import ImagesFooter2025InstagramSvg from '@/public/images/footer-2025/instagram.svg';
import ImagesFooter2025TiktokSvg from '@/public/images/footer-2025/tiktok.svg';
import ImagesFooter2025YoutubeSvg from '@/public/images/footer-2025/youtube.svg';

export {
  ImagesFooter2025FacebookSvg,
  ImagesFooter2025InstagramSvg,
  ImagesFooter2025TiktokSvg,
  ImagesFooter2025YoutubeSvg,
};
